import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Kostar kunskapsprovet extra utöver ansökan?";
const SHORT_ANSWER = "I många kommuner ingår första försöket i ansökningsavgiften, men omprov kan kosta 1 000–2 500 kr enligt kommunens taxa.";

export const Route = createFileRoute("/fraga/kostar-kunskapsprovet-extra")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Kostar kunskapsprovet extra utöver ansökan" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Kostnaden för omprov varierar mellan kommuner. Stockholm och Göteborg har normalt högre avgifter. Kontrollera alltid med din kommun innan du bokar."}
      source={{ label: "Folkhälsomyndigheten – Kunskapsprov", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/kunskapsprov/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/vad-kostar-serveringstillstand", label: "Vad kostar serveringstillstånd – priser" }}
      related={[{"to": "/fraga/hur-manga-forsok-har-jag", "label": "Hur många försök har jag på kunskapsprovet?"}, {"to": "/fraga/vad-hander-om-jag-blir-underkand", "label": "Vad händer om jag blir underkänd på kunskapsprovet?"}, {"to": "/fraga/far-jag-anvanda-lagboken", "label": "Får jag använda lagboken på kunskapsprovet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Kostar kunskapsprovet extra utöver ansökan?" },
      { name: "description", content: "I många kommuner ingår första försöket i ansökningsavgiften, men omprov kan kosta 1 000–2 500 kr enligt kommunens taxa." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/kostar-kunskapsprovet-extra" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/kostar-kunskapsprovet-extra" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/kostar-kunskapsprovet-extra",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Kostar kunskapsprovet extra utöver ansökan", url: "https://alkoholprovet.se/fraga/kostar-kunskapsprovet-extra" },
      ]),
    ],
  }),
});
